import { API } from "../api/axios";
const END_POINT = "/payments";
const END_POINT_SOLDE = "/solde-students";
const END_POINT_PAYEMENT = "/payment";
const END_POINT_STUDENT = "/student";
const END_POINT_PARENT_YEAR = "/payment-filter/school-year";
const END_POINT_PAYEMENT_YEAR = "/student-parent";
const END_POINT_FACTURATION ="/facturation-student"
const END_POINT_SERVICE ="/services/students-list"
const END_POINT_FILTER= "/time-sheet-filter";
const END_POINT_CLASS= "/time-sheet-class";

const END_POINT_YEAR = "/school-session";

const END_POINT_SERVICE_STATUS = "/service-students";

class PaymentService {
    getAll(params) {
        return API.get(END_POINT_SOLDE, params);
    }
    get(id) {
        return API.get(`${END_POINT_PAYEMENT}/${id}`);
    }
    getSchoolSession() {
        return API.get(`${END_POINT_YEAR}`);
    }
    getYear(id1,id2,params) {
        return API.get(`${END_POINT_PARENT_YEAR}/${id1}${END_POINT_STUDENT}/${id2}`,params);
    }
    facture(id) {
        return API.post(`${END_POINT_FACTURATION}/${id}`);
    }
    create(data,id) {
        return API.post(`${END_POINT_PAYEMENT}/${id}`, data);
    }
    studentsList(params) {
        return API.get(END_POINT_SERVICE, params);
    }
    getFilter(params) {
        return API.get(END_POINT_FILTER, params);
    }
    getClass(params) {
        return API.get(END_POINT_CLASS, params);
    }
    updateStatus(data) {
        return API.post(`${END_POINT_SERVICE_STATUS}`, data);
    }


}

export default new PaymentService();
